import { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import logo from '../../assets/logo.png';

export default function Header() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const location = useLocation();

  const isActive = (path: string) => location.pathname === path;

  return (
    <header className="fixed top-0 left-0 right-0 bg-white shadow-sm z-50">
      <div className="bg-[#0F172A] text-white py-2">
        <div className="container mx-auto px-4 flex justify-between items-center text-sm">
          <div className="flex items-center gap-4">
            <a href="tel:+351927613501" className="flex items-center gap-2 hover:text-[#00A884] transition-colors cursor-pointer">
              <i className="ri-phone-line"></i>
              <span>+351 927 613 501</span>
            </a>
            <a href="mailto:friotecavac@gmail.com" className="hidden md:flex items-center gap-2 hover:text-[#00A884] transition-colors cursor-pointer">
              <i className="ri-mail-line"></i>
              <span>friotecavac@gmail.com</span>
            </a>
          </div>
          <div className="flex items-center gap-3">
            <a href="https://facebook.com" target="_blank" rel="noopener noreferrer" className="w-8 h-8 flex items-center justify-center hover:text-[#00A884] transition-colors cursor-pointer">
              <i className="ri-facebook-fill text-lg"></i>
            </a>
            <a href="https://instagram.com" target="_blank" rel="noopener noreferrer" className="w-8 h-8 flex items-center justify-center hover:text-[#00A884] transition-colors cursor-pointer">
              <i className="ri-instagram-line text-lg"></i>
            </a>
            <a href="https://youtube.com" target="_blank" rel="noopener noreferrer" className="w-8 h-8 flex items-center justify-center hover:text-[#00A884] transition-colors cursor-pointer">
              <i className="ri-youtube-line text-lg"></i>
            </a>
          </div>
        </div>
      </div>

      <div className="container mx-auto px-4">
        <div className="flex items-center justify-between h-20">
          <Link to="/" className="flex items-center gap-3 cursor-pointer">
            <img 
              src={logo} 
              alt="Friotec Logo" 
              className="h-16 w-auto object-contain"
            />
            <div className="flex flex-col">
              <span className="text-2xl font-bold text-[#0A6DAF]">Friotec</span>
              <span className="text-xs text-gray-600 -mt-1">Climatização</span>
            </div>
          </Link>

          <nav className="hidden lg:flex items-center gap-8">
            <Link 
              to="/" 
              className={`text-sm font-medium transition-colors cursor-pointer whitespace-nowrap ${
                isActive('/') ? 'text-[#0A6DAF]' : 'text-gray-700 hover:text-[#0A6DAF]'
              }`}
            >
              Home
            </Link>
            <Link 
              to="/servicos" 
              className={`text-sm font-medium transition-colors cursor-pointer whitespace-nowrap ${
                isActive('/servicos') ? 'text-[#0A6DAF]' : 'text-gray-700 hover:text-[#0A6DAF]'
              }`}
            >
              Serviços
            </Link>
            <Link 
              to="/vendas" 
              className={`text-sm font-medium transition-colors cursor-pointer whitespace-nowrap ${
                isActive('/vendas') ? 'text-[#0A6DAF]' : 'text-gray-700 hover:text-[#0A6DAF]'
              }`}
            >
              Vendas
            </Link>
            <Link 
              to="/sobre" 
              className={`text-sm font-medium transition-colors cursor-pointer whitespace-nowrap ${
                isActive('/sobre') ? 'text-[#0A6DAF]' : 'text-gray-700 hover:text-[#0A6DAF]'
              }`}
            >
              Sobre nós
            </Link>
            <Link 
              to="/contato" 
              className={`text-sm font-medium transition-colors cursor-pointer whitespace-nowrap ${
                isActive('/contato') ? 'text-[#0A6DAF]' : 'text-gray-700 hover:text-[#0A6DAF]'
              }`}
            >
              Contato
            </Link>
          </nav>

          <div className="hidden lg:flex items-center gap-3">
            <Link 
              to="/simulador" 
              className="px-5 py-2.5 bg-white border-2 border-[#0A6DAF] text-[#0A6DAF] rounded-lg font-medium hover:bg-[#0A6DAF] hover:text-white transition-all cursor-pointer whitespace-nowrap text-sm"
            >
              Simulador BTU
            </Link>
            <a 
              href="https://wa.me/351927613501?text=Olá,%20gostaria%20de%20solicitar%20um%20orçamento" 
              target="_blank" 
              rel="noopener noreferrer"
              className="px-5 py-2.5 bg-gradient-to-r from-[#0A6DAF] to-[#00A884] text-white rounded-lg font-medium hover:shadow-lg transition-all cursor-pointer whitespace-nowrap text-sm flex items-center gap-2"
            >
              <i className="ri-whatsapp-line text-lg"></i>
              Solicitar Orçamento
            </a>
          </div>

          <button 
            onClick={() => setIsMenuOpen(!isMenuOpen)}
            className="lg:hidden w-10 h-10 flex items-center justify-center text-gray-700 cursor-pointer"
          >
            <i className={`${isMenuOpen ? 'ri-close-line' : 'ri-menu-line'} text-2xl`}></i>
          </button>
        </div>
      </div>

      {isMenuOpen && (
        <div className="lg:hidden bg-white border-t">
          <nav className="container mx-auto px-4 py-4 flex flex-col gap-3">
            <Link to="/" className="py-2 text-gray-700 hover:text-[#0A6DAF] cursor-pointer" onClick={() => setIsMenuOpen(false)}>Home</Link>
            <Link to="/servicos" className="py-2 text-gray-700 hover:text-[#0A6DAF] cursor-pointer" onClick={() => setIsMenuOpen(false)}>Serviços</Link>
            <Link to="/vendas" className="py-2 text-gray-700 hover:text-[#0A6DAF] cursor-pointer" onClick={() => setIsMenuOpen(false)}>Vendas</Link>
            <Link to="/sobre" className="py-2 text-gray-700 hover:text-[#0A6DAF] cursor-pointer" onClick={() => setIsMenuOpen(false)}>Sobre nós</Link>
            <Link to="/contato" className="py-2 text-gray-700 hover:text-[#0A6DAF] cursor-pointer" onClick={() => setIsMenuOpen(false)}>Contato</Link>
            <Link to="/simulador" className="py-2 text-[#0A6DAF] font-medium cursor-pointer" onClick={() => setIsMenuOpen(false)}>Simulador BTU</Link>
            <a 
              href="https://wa.me/351927613501?text=Olá,%20gostaria%20de%20solicitar%20um%20orçamento" 
              target="_blank" 
              rel="noopener noreferrer"
              className="mt-2 px-5 py-2.5 bg-gradient-to-r from-[#0A6DAF] to-[#00A884] text-white rounded-lg font-medium text-center cursor-pointer whitespace-nowrap"
            >
              Solicitar Orçamento
            </a>
          </nav>
        </div>
      )}
    </header>
  );
}